import React from 'react';
import { CircularProgress, Box, Grid } from '@mui/material';

export const Loader = ({ loading }) => {
  return (
    <Box clone bgcolor="primary.main">
      <Grid
        container
        style={{
          height: '100vh',
          position: 'fixed',
          top: 0,
          opacity: loading ? 1 : 0,
          visibility: loading ? 'visible' : 'hidden',
          transition: '0.5s',
          zIndex: 100,
          backgroundColor: 'rgba(0,0,0,0.1)',
        }}
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress color="primary" />
      </Grid>
    </Box>
  );
};
